import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Container } from '@mui/material';
import ScrollTop from './components/ScrollTop';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Agreement from './pages/Agreement';
import Policies from './pages/Policies';
import Booking from './pages/Booking';
import NavigationBar from './components/NavigationBar';
import Jokgu from './pages/Jokgu';
import checkAndRemoveExpiredToken from './utils/checkAndRemoveExpiredToken';

export default function App() {
  useEffect(() => {
    checkAndRemoveExpiredToken();
  }, []);

  return (
    <Container
      sx={{
        width: '100%',
        px: '0 !important',
        position: 'absolute',
        top: '0',
        left: '0',
        maxWidth: '100% !important',
      }}
    >
      <BrowserRouter>
        <ScrollTop />
        <NavigationBar />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/agreement" element={<Agreement />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/jokgu" element={<Jokgu />} />
        </Routes>
      </BrowserRouter>
    </Container>
  );
}
